/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SubmissionState = {
    Unsubmitted: 'UNSUBMITTED',
    Submitted: 'SUBMITTED',
    ClonedSubmitted: 'CLONED_SUBMITTED'
} as const;
export type SubmissionState = typeof SubmissionState[keyof typeof SubmissionState];


export function instanceOfSubmissionState(value: any): boolean {
    for (const key in SubmissionState) {
        if (Object.prototype.hasOwnProperty.call(SubmissionState, key)) {
            // @ts-ignore
            if (SubmissionState[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SubmissionStateFromJSON(json: any): SubmissionState {
    return SubmissionStateFromJSONTyped(json, false);
}

export function SubmissionStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionState {
    return json as SubmissionState;
}

export function SubmissionStateToJSON(value?: SubmissionState | null): any {
    return value as any;
}

